import React from 'react'
import { QuestionFrame, RadioQuestion, YesNoQuestion } from 'components/questions'
import { useGlobalState } from 'state'
import { getQuestionKey } from 'common/utils'


export const Q07 = () => {
  const state = useGlobalState()
  const NO_VALUE = 'いいえ（どちらにも該当しません）'

  const answer1 = React.useMemo(() => {
    return state.app.getAnswer(7, 1)
  }, [state.app.answers])

  React.useEffect(() => {
    if (answer1 === null) {
      return
    }
    const nextAnswers = {
      ...state.app.answers
    }
    if (answer1.value === NO_VALUE) {
      nextAnswers[getQuestionKey(7, 2)] = {value: '', valid: true}
      nextAnswers[getQuestionKey(7, 3)] = {value: '', valid: true}
    } else {
      const q7_2 = nextAnswers[getQuestionKey(7, 2)]
      const q7_3 = nextAnswers[getQuestionKey(7, 3)]
      if (q7_2 === undefined || q7_2.value === '') {
        nextAnswers[getQuestionKey(7, 2)] = {value: '', valid: false}
      }
      if (q7_3 === undefined || q7_3.value === '') {
        nextAnswers[getQuestionKey(7, 3)] = {value: '', valid: false}
      }
    }
    state.app.setAnswers(nextAnswers)
  }, [answer1])

  return (
    <QuestionFrame q={7}>

      <RadioQuestion
        num={1}
        content={'公共の雨水・下水本管から建物内への逆流防止対策（逆流防止弁、止水弁、又はこれに代わる設備を設置）又は、公共の雨水・下水本管へ放流せず敷地内処理をしていますか。'}
        row
        items={state.scoring.getRadioItems('q7-1')}
      />
      { (answer1 && answer1.value !== NO_VALUE) && (
        <>
          <YesNoQuestion num={2} content={'①で逆流防止対策をしている場合、当該設備に関して年１回以上の動作確認又は操作訓練を実施していますか。'} />
          <YesNoQuestion num={3} content={'①で逆流防止対策をしている場合、当該設備に関して緊急対応マニュアルに逆流防止弁、止水弁等の運用に関する規程はありますか。'} />
        </>
      )}

    </QuestionFrame>
  )
}
